var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--shared_less-more-text less-more-text",
    class: {
      collapsed: _vm.collapsed
    }
  }, [_c('p', {
    ref: "lessMoreTextP",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _vm.viewLessMore ? _c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.lessMore.apply(null, arguments);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.collapsed ? _vm.buttonMoreText : _vm.buttonLessText) + "\n  ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }